import { Galleria } from "primereact/galleria";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import banner3 from "../../../assets/images/home/banners/MULTISUOOUROCARd2.png";
import banner4 from "../../../assets/images/home/banners/Multiusocard1.png";
import { AdsPlaceHolder } from "../../../components/adsPlaceHolder";
import { Carrousel } from "../../../components/carrousel";
import { Loading } from "../../../components/loading";
import { ICarrossel } from "../../../interfaces/model/iCarrossel";
import carrosselService from "../../../services/carrosselService";
import publicidadesService from "../../../services/publicidadesService";
import { findAdsByName, scrollUp } from "../../../utils/pageUtils";
import { CaroselWrapper, HomeContainer, PositionAds } from "./styles";

export const InitContainers = () => {
  const galleria = useRef<Galleria>(null);
  const galleria2 = useRef<Galleria>(null);

  const navigate = useNavigate();

  const [isLoading] = useState<boolean>(false);
  const [carrouselNews, setCarrouselNews] = useState<ICarrossel[] | null>(null);
  const [home, setHome] = useState<IPublicidades | undefined>();

  const [selectedImage, setSelectedImage] = useState("");
  const itemTemplate = (item: any) => {
    return (
      <img
        src={item}
        alt="Informações do convênio AFESP"
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const getAds = useCallback(() => {
    publicidadesService
      .getAllAds()
      .then((res) => {
        res && setHome(findAdsByName({ nome: "Home 1", array: res.data }));
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }, []);

  const getCarrossel = useCallback(() => {
    carrosselService
      .getAll()
      .then((res) => {
        const normalizedItems = (res.data as any[]).map((item) => ({
          id: item?.id,
          titulo: item?.titulo ?? item?.link ?? item?.title ?? "",
          texto: item?.texto ?? item?.descricao ?? item?.subTitle ?? "",
          imagem: item?.imagem ?? item?.image ?? "",
        }));

        const validItems = normalizedItems.filter((item) => {
          const hasImagem = !!item?.imagem?.trim();
          const hasContent = !!item?.titulo?.trim() || !!item?.texto?.trim();

          return hasImagem && hasContent;
        });

        setCarrouselNews(validItems);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }, []);

  useEffect(() => {
    scrollUp();
    getAds();
    getCarrossel();
  }, [getAds, getCarrossel]);

  const carrouselImageClick = (image: any) => {
    if (image.imageBanner) {
      if (image.title.includes("Cartão Afesp MultiusoCard Três em Um.")) {
        galleria2.current?.show();
      } else {
        setSelectedImage(image.imageBanner);
        galleria.current?.show();
      }
    } else if (image.routerLink) {
      if (image.routerLink.includes("afesptv")) {
        window.open(image.routerLink);
      } else {
        navigate(image.routerLink);
      }
    }
  };

  return (
    <HomeContainer>
      <Galleria
        ref={galleria}
        value={[selectedImage]}
        numVisible={1}
        style={{
          maxWidth: "920px",
          width: "100%",
          padding: "1rem",
          margin: "auto",
        }}
        circular
        fullScreen
        showThumbnails={false}
        item={itemTemplate}
      />
      <Galleria
        ref={galleria2}
        value={[banner4, banner3]}
        numVisible={1}
        style={{
          maxWidth: "920px",
          width: "100%",
          padding: "1rem",
          margin: "auto",
        }}
        fullScreen
        showItemNavigators
        showThumbnails={false}
        item={itemTemplate}
      />
      <Loading isLoading={isLoading} />
      {!isLoading && (
        <>
          <CaroselWrapper>
            {carrouselNews && carrouselNews.length > 0 && (
              <Carrousel
                newsList={carrouselNews}
                onImageClick={carrouselImageClick}
              />
            )}
          </CaroselWrapper>

          {home && carrouselNews && carrouselNews.length > 0 && (
            <PositionAds>
              <AdsPlaceHolder
                key={home.id}
                image={home.imagemWeb + ""}
                image2={home.imagemMobile + ""}
                link={home.linkUrl + ""}
              />
            </PositionAds>
          )}
        </>
      )}
    </HomeContainer>
  );
};

export interface IPublicidades {
  id?: number;
  nome: string;
  imagemWeb?: string;
  recomendadoWeb: string;
  imagemMobile?: string;
  recomendadoMobile: string;
  linkUrl: string;
}

export interface INoticia {
  id: number;
  categoria: ICategoria;
  titulo: string;
  imagem: string;
  video: string;
  data: string;
  autor: string;
  cidade: string;
  slug?: string;
}

export interface ICategoria {
  id: number;
  nome: string;
  imagem?: string;
}
